
import Vue from "vue"
import MenuItem from './index.vue'
import Preview from '@/components/preview/index.vue'
export default Vue.extend({
   components:{
	 MenuItem,
	 Preview
   }
})
